export enum UserTypeEnum {
  Staff = 'staff',
  Resident = 'resident',
  FamilyHubMember = 'familyHubMember',
  Family = 'family',
  Kiosk = 'kiosk'
}